import React from 'react';
import { Button } from 'ff/debrief/common/components/StyledComponents/Buttons';

interface Props {
    isEditMode: boolean;
    disabled: boolean;
    onEditClick: () => void;
    onSaveClick: () => void;
    onResetClick: () => void;
    onCancelClick: () => void;
    vrefSource?: string;
}

const EditControls: React.FC<Props> = props => {
    const isVSpeeds = props.vrefSource?.includes('V-Speeds');

    if (props.isEditMode) {
        return (
            <div style={{ display: 'flex' }}>
                <Button
                    variant="contained"
                    tiny={true}
                    onClick={props.onSaveClick}
                    style={{ fontWeight: 'bold' }}
                >
                    Ok
                </Button>
                <Button
                    variant="outlined"
                    tiny={true}
                    onClick={props.onResetClick}
                    disabled={isVSpeeds}
                    style={{ fontWeight: 'bold' }}
                >
                    Reset
                </Button>
                <Button
                    variant="outlined"
                    tiny={true}
                    onClick={props.onCancelClick}
                    style={{ fontWeight: 'bold' }}
                >
                    Cancel
                </Button>
            </div>
        );
    } else {
        return (
            <Button
                disabled={props.disabled}
                variant="outlined"
                tiny={true}
                onClick={props.onEditClick}
                style={{ fontWeight: 'bold' }}
            >
                Edit
            </Button>
        );
    }
};

export default EditControls;
